<!-- 请在微信中打开链接 -->
<template>
  <div class="pls-wechat">
    <van-icon
      name="info"
      color="rgb(25, 137, 250)"
      size="100"
    />
    <div class="pls-context">请在微信客户端打开链接</div>
  </div>

</template>

<script>
export default {
  name: 'pls-wechat',
  mounted() {
     // 判断是否微信浏览器,是则回主页
    const ua = navigator.userAgent.toLowerCase()
    const isWeixin = ua.indexOf('micromessenger') !== -1
    if (isWeixin) {
        this.$router.push('/')
    }
  }
}
</script>

<style lang="less" scoped>
  .pls-wechat {
    height: 70vh;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }
  .pls-context {
    font-size: 16px;
    padding-top: 20px;
  }
</style>
